import React, { useContext, useEffect, useRef, useState } from "react";

import makeStyles from "@mui/styles/makeStyles";
import LanguageContext from "../LanguageContext";
import UserService from "../services/UserService";
import {
  Close,
  ExpandLess,
  ExpandMore,
  ThumbUp,
  ThumbUpOutlined,
  Visibility,
} from "@mui/icons-material";
import _ from "lodash";
import { useHistory, useLocation, useParams } from "react-router-dom";

import firebase from "../firebase";
import ErrorBoundary from "./ErrorBoundry";
import ReactVideoPlayer from "./ReactVideoPlayer";
import VideosService from "../services/VideosService";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import config from "../config";
import Typography from "@mui/material/Typography";
import messages from "../services/messages";
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  IconButton,
} from "@mui/material";
import Container from "@mui/material/Container";
import { WhatsappShareButton } from "react-share";
import { Navigation, Virtual } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css/bundle";

import Button from "@mui/material/Button";
// import Bowser from "bowser";
import content from "../services/content";
import ProductService from "../services/ProductService";
import CropService from "../services/CropService";
import StateService from "../services/StateService";
import moment from "moment/moment";
import AuthorService from "../services/AuthorService";
import StageService from "../services/StageService";
import ZoomService from "../services/ZoomService";
import queryStringParser from "query-string";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
// const browser = Bowser.getParser(window.navigator.userAgent);

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#000000",
    height: window.innerHeight,
    // flexGrow: "1",
  },
  avatar: {
    height: theme.spacing(4),
    width: theme.spacing(4),
  },
  // ytPlayerContainer: {
  //   // marginTop: theme.spacing(3),
  //   height: "45vh",
  // },
  ytDialog: {
    background: "#000000",
  },
  ytPlayer: {
    // height: "100vh",
    // alignItems: "center",
    // justifyContent: "center",
    // marginTop:theme.spacing(2),
    backgroundColor: "black",
  },
  closeButtonContainer: {},
  ytPlayerClose: {},
  ytPlayerCloseIcon: {
    cursor: "pointer",
    fontSize: theme.spacing(3),
    backgroundColor: "transparent",
    color: "white ",
  },
  swiperContainer: {
    height: "1280px",
    maxHeight: window.innerHeight,
    overscrollBehavior: "contain",
  },
  swiperSlide: {
    background: "#000000",
    // height: "640px",
  },
  videoMetadata: {
    marginTop: "-47vh",
  },
  videoMetadataShared: { marginTop: "-47vh" },

  titleContainer: {
    // marginTop: theme.spacing(-2.5),
  },
  authorContainer: {
    marginTop: theme.spacing(0.2),
  },
  skusContainer: {
    marginTop: theme.spacing(0),
  },
  skuImage: {
    marginBottom: theme.spacing(-0.9),
  },
  skuClickHere: {
    fontSize: "12px",
    height: 18,
    padding: -1,
    marginBottom: theme.spacing(-1.2),
    borderRadius: "0",
  },
  viewsContainer: {
    marginTop: theme.spacing(0),
  },
  nextButtonContainer: {
    marginTop: theme.spacing(0.5),
    // position: "fixed",
    // top: window.innerHeight - 40,
    // bottom:
    //   browser.getBrowserName() === "Chrome"
    //     ? navigator.userAgent.includes("wv")
    //       ? theme.spacing(2)
    //       : theme.spacing(8)
    //     : theme.spacing(2),
    background: "#000000",
  },
  nextButton: {
    marginLeft: theme.spacing(-1),
    // marginRight: theme.spacing(-2),
    color: "#FFFFFF",
    borderColor: "#CCCCCC",
    background: "#212121",
    fontSize: theme.spacing(1.5),
    "&:hover": {
      color: "#FFFFFF",
      background: "#212121",
    },
    "&:disabled": {
      background: "#212121",
      color: "#F1F1F1",
      opacity: "0.3",
    },
  },
  verticalRule: {
    borderLeft: "1px solid #CCCCCC",
    height: theme.spacing(1.4),
    marginBottom: theme.spacing(1.5),
    marginLeft: theme.spacing(-1.3),
  },
  previousButton: {
    // marginLeft: theme.spacing(-5.9),
    color: "#FFFFFF",
    borderColor: "#CCCCCC",
    background: "#212121",
    fontSize: theme.spacing(1.5),
    "&:hover": {
      color: "#FFFFFF",
      background: "#212121",
    },
    "&:disabled": {
      background: "#212121",
      color: "#F1F1F1",
      opacity: "0.3",
    },
  },

  contentVideoTitle: {
    fontWeight: 600,
    color: "#FFFFFF",
    // fontSize:"14px",
    // marginTop: theme.spacing(1),
  },
  authorName: {
    marginLeft: theme.spacing(-0.5),
    fontSize: "12px",
    color: "#FFFFFF",
  },
  skuCard: {
    marginTop: theme.spacing(-1),
    backgroundColor: "#000000",
    cursor: "pointer",
  },
  skusTitle: {
    marginTop: theme.spacing(1),
    fontSize: "14px",
    color: "#FFFFFF",
  },
  skuCardContent: {
    padding: theme.spacing(0.5),
    marginBottom: theme.spacing(-2),
  },
  viewsIconContainer: {
    marginBottom: theme.spacing(-0.5),
    marginTop: theme.spacing(-0.6),
    // marginLeft: theme.spacing(-1),
  },
  viewsIcon: {
    color: "#FFFFFF",
    height: theme.spacing(2.5),
    opacity: "0.6",
    // marginTop: theme.spacing(-1),
    // marginLeft: theme.spacing(-1),
  },
  viewsCount: {
    color: "#FFFFFF",
    opacity: "0.6",
    // marginTop: theme.spacing(-1),
  },
  newTagContainer: {
    marginBottom: theme.spacing(0.8),
    marginTop: theme.spacing(0.2),
    marginLeft: theme.spacing(0.1),
    paddingLeft: theme.spacing(0.3),
    paddingRight: theme.spacing(0.3),
    paddingBottom: theme.spacing(0),
    paddingTop: theme.spacing(0.2),
    borderRadius: theme.spacing(0.3),
    color: "#FFFFFF",
    height: theme.spacing(2.5),
    background: "#ef5350",
  },
  newTag: {},
  socialActionContainer: {
    marginLeft: theme.spacing(-1.5),
    // marginTop: "-1vh",
    // position: "fixed",
    // bottom: "7vh",
    // right: "4vw",
  },
  shareIconContainer: {
    // marginLeft: theme.spacing(-0.5),
    marginTop: theme.spacing(-1),
  },
  shareIcon: {
    color: "#FFFFFF",
    // padding: theme.spacing(-0.5),
    // marginTop: theme.spacing(0.5),
    height: theme.spacing(4),
  },
  sharesCountContainer: {
    marginTop: theme.spacing(-1),
    color: "#FFFFFF",
  },
  sharesCount: {
    marginLeft: theme.spacing(-2.3),
  },
  likeButton: {
    color: "#FFFFFF",
    marginTop: theme.spacing(-0.5),
    // height: theme.spacing(1),
  },
  likeIcon: {
    color: "#FFFFFF",
    // marginTop: theme.spacing(-1),
    height: theme.spacing(4),
  },
  unlikeIcon: {
    color: "#FFFFFF",
    // marginTop: theme.spacing(-1),
    height: theme.spacing(4),
  },
  likesCountContainer: {
    marginTop: theme.spacing(-2),
    color: "#FFFFFF",
  },
  likesCount: {
    marginLeft: theme.spacing(-2.3),
  },
  playerWrapper: {
    height: "100%",
    width: "100%",
    overflow: "hidden",
    marginTop: theme.spacing(0),
    paddingTop: theme.spacing(1),
    // marginBottom: theme.spacing(-2.2),
  },
}));
function ContentVideoDialog(props) {
  const classes = useStyles();
  let history = useHistory();
  const location = useLocation();
  const [products, setProducts] = useState(null);
  const [swiper, setSwiper] = useState(null);
  // const slideTo = (index) => swiper.slideTo(index);
  const cropNameObjFromRoute = useParams("crop");
  const cropNameFromRoute = cropNameObjFromRoute.crop;
  const youtubeIdObjFromRoute = useParams("youtube_id");
  const youtubeIdFromRoute = youtubeIdObjFromRoute.youtube_id;
  console.log({ youtubeIdFromRoute });
  // const language = useContext(LanguageContext);
  let [userState, setUserState] = useState("");
  const [open, setOpen] = React.useState(true);
  let [jwtToken, setJwtToken] = useState("");
  let [userLanguageCode, setUserLanguageCode] = useState("");
  let [recordedMeetings, setRecordedMeetings] = useState({});
  let [loadingRecordedMeetings, setLoadingRecordedMeetings] = useState(false);
  let [upcomingMeetings, setUpcomingMeetings] = useState({});
  let [allUpcomingMeetings, setAllUpcomingMeetings] = useState([]);
  let [allMeetingsByCrop, setAllMeetingsByCrop] = useState({});
  let [allMeetingsByCropFiltered, setAllMeetingsByCropFiltered] = useState({});
  let [loadingUpcomingMeetings, setLoadingUpcomingMeetings] = useState(false);
  let [liveMeetings, setLiveMeetings] = useState([]);
  let [loadingLiveMeetings, setLoadingLiveMeetings] = useState(false);
  let [recordedVideosCount, setRecordedVideosCount] = useState(null);
  let [upcomingMeetingsCount, setUpcomingMeetingsCount] = useState(null);
  let [loading, setLoading] = useState(false);
  let [free, setFree] = useState(false);
  let [name, setName] = useState(null);
  let [mobile, setMobile] = useState(null);
  let [farmerCrops, setFarmerCrops] = useState([]);
  let [cropList, setCropList] = useState([]);
  let [loadingCropList, setLoadingCropList] = useState(false);
  let userTypeVar = "premium";
  let [userType, setUserType] = useState(userTypeVar);
  let freeVar = false;
  let [contentVideos, setContentVideos] = useState(null);
  let [videosCount, setVideosCount] = useState(null);
  let [contentVideosCount, setContentVideosCount] = useState(null);
  let [recordingsCount, setRecordingsCount] = useState(null);
  let [sowingDate, setSowingDate] = useState(null);
  let [currentDaysAfterSowing, setCurrentDaysAfterSowing] = useState(null);
  let [currentWeeksAfterSowing, setCurrentWeeksAfterSowing] = useState(null);
  let [userSource, setUserSource] = useState("");
  let [visibleContentVideos, setVisibleContentVideos] = useState([]);

  let cropFromRoute = {};
  if (props.referenceData && props.referenceData.crops) {
    cropFromRoute = CropService.getCropByName(
      props.referenceData.crops,
      cropNameFromRoute
    );
  }

  let [contentVideoCurrent, setContentVideoCurrent] = useState(null);
  let [activeSlideIndex, setActiveSlideIndex] = useState(0);

  const language = location?.state?.userLanguage ? "mr" : "mr";

  const getContentVideo = () => {
    let contentVideo = null;

    return getContentVideoFromYoutubeId(youtubeIdFromRoute);
  };
  useEffect(() => {
    // let contentVideo = getContentVideo();
    // console.log({ contentVideo });
    // console.log({ contentVideos });
    // setContentVideos(videosData);
    // let currentVideoPosition = _.findIndex(
    //     contentVideos,
    //     (videoElement) => {
    //       return videoElement.youtube_id === contentVideo.youtube_id;
    //     }
    // );
    // if (currentVideoPosition !== -1) {
    //   setActiveSlideIndex(currentVideoPosition);
    // }
    // console.log({ currentVideoPosition });
    // setProducts(null);
    // console.log(`active slide change ${activeSlideIndex}`)
    if (contentVideos?.length > 0) {
      console.log("has contentvideos");
      console.log(getContentVideo());
      setContentVideoCurrent(getContentVideo());
      let contentVideo = getContentVideo();
      if (contentVideo.skus && contentVideo.skus.length > 0) {
        let skusToFetch = contentVideo.skus.join(",");

        // ProductService.getProductsListBySKUs(skusToFetch)
        //   .then((response) => {
        //     if (response?.data?.responseData?.productGists?.length > 0) {
        //       let productsFromResponse =
        //         response.data.responseData.productGists;
        //       setProducts(productsFromResponse);
        //     } else {
        //       console.log(`no response received in responseData`);
        //     }
        //   })
        //   .catch((error) => {
        //     console.log(`error getting products`);
        //     if (error.data) {
        //       console.log(error.data);
        //     } else {
        //       console.log(error);
        //     }
        //   });
      }
      firebase.analytics().logEvent("content_video_page_viewed", {
        mobile,
        flow: "from-crop-page",
        crop_name: contentVideo.cropData.name_en,
        author_name: contentVideo.authorData.name_en,
        title: contentVideo.title,
        weeks_after_sowing: contentVideo.weeks_after_sowing,
        stage: contentVideo.stageData.name_en,
        crop_age: contentVideo.crop_age,
        state: contentVideo.stateData.name_en,
        // position: location.state.position,
        // user_type: location.state.userType,
        // users_source: location.state.userSource,
        // farmer_crops: JSON.stringify(location.state.farmerCrops),
        crop_segment: contentVideo.crop_segment,
        youtube_id: youtubeIdFromRoute,
        skus: contentVideo.skus,
      });
    } else {
      firebase.analytics().logEvent("content_video_page_viewed", {
        flow: "shared-url",
        youtube_id: youtubeIdFromRoute,
        crop_name: cropNameFromRoute,
      });
    }
  }, [contentVideos]);
  const getShareText = () => {
    let shareText = `${contentVideoCurrent.cropName} ${messages["cropPage.contentVideo.shareText"][language]} https://${window.location.hostname}/crop/${cropNameFromRoute}/content/${contentVideoCurrent.youtube_id} ${messages["cropPage.contentVideo.agrostarAppShareText"][language]}`;
    if (contentVideoCurrent?.cropData?.name_en === "Weather") {
      shareText = `${contentVideoCurrent.cropName} ${messages["cropPage.contentVideo.shareText"][language]} https://${window.location.hostname}/crop/${cropNameFromRoute}/content/${contentVideoCurrent.youtube_id} ${messages["cropPage.contentVideo.agrostarAppShareText"][language]}`;
    }
    return shareText;
  };
  const share = async (event) => {
    event.stopPropagation();

    const { mobile } = UserService.getUserInfo();

    firebase.analytics().logEvent("content_video_shared_on_whatsapp", {
      mobile,
      crop_name: contentVideoCurrent.cropData.name_en,
      author_name: contentVideoCurrent.authorData.name_en,
      title: contentVideoCurrent.title,
      weeks_after_sowing: contentVideoCurrent.weeks_after_sowing,
      stage: contentVideoCurrent.stageData.name_en,
      state: contentVideoCurrent.stateData.name_en,
      // position: location.state.position,
      user_type: props.userType,
      crop_segment: contentVideoCurrent.crop_segment,
      user_source: props?.userSource,
      page_name: window.location.pathname,
      skus: contentVideoCurrent.skus,
    });

    let newSharesCount = contentVideoCurrent.shares_count
      ? contentVideoCurrent.shares_count + 1
      : 1;

    setContentVideoCurrent({
      ...contentVideoCurrent,
      shares_count: newSharesCount,
    });

    if (contentVideoCurrent && contentVideoCurrent !== undefined) {
      VideosService.logVideoActivity(contentVideoCurrent.youtube_id, "shared")
        .then(() => {})
        .catch(() => {});
    }
  };

  const likeAVideo = (event) => {
    event.stopPropagation();
    const mobile = localStorage.getItem("mobile");

    VideosService.logVideoActivity(
      contentVideoCurrent.youtube_id,
      "liked",
      mobile
    )
      .then(() => {})
      .catch(() => {});

    let newLikes = contentVideoCurrent.likes
      ? contentVideoCurrent.likes + 1
      : 1;

    setContentVideoCurrent({
      ...contentVideoCurrent,
      likes: newLikes,
      likedByMe: true,
    });

    firebase.analytics().logEvent("content_video_liked", {
      crop_name: contentVideoCurrent.cropData.name_en,
      author_name: contentVideoCurrent.authorData.name_en,
      title: contentVideoCurrent.title,
      weeks_after_sowing: contentVideoCurrent.weeks_after_sowing,
      stage: contentVideoCurrent.stageData.name_en,
      crop_age: contentVideoCurrent.crop_age,
      state: contentVideoCurrent.stateData.name_en,
      // position: location.state.position,
      // user_type: location.state.userType,
      // farmer_crops: JSON.stringify(location.state.farmerCrops),
      crop_segment: contentVideoCurrent.crop_segment,
      youtube_id: contentVideoCurrent.youtube_id,
      // user_source: location.state.userSource,
      page_name: window.location.pathname,
      skus: contentVideoCurrent.skus,
    });
  };

  const unlikeAVideo = (event) => {
    event.stopPropagation();

    VideosService.logVideoActivity(
      contentVideoCurrent.youtube_id,
      "unliked",
      localStorage.getItem("mobile")
    )
      .then(() => {})
      .catch(() => {});

    let newLikes = contentVideoCurrent.likes
      ? contentVideoCurrent.likes - 1
      : 0;

    console.log({ newLikes });

    setContentVideoCurrent({
      ...contentVideoCurrent,
      likes: newLikes,
      likedByMe: false,
    });

    firebase.analytics().logEvent("content_video_unliked", {
      crop_name: contentVideoCurrent.cropData.name_en,
      author_name: contentVideoCurrent.authorData.name_en,
      title: contentVideoCurrent.title,
      weeks_after_sowing: contentVideoCurrent.weeks_after_sowing,
      stage: contentVideoCurrent.stageData.name_en,
      crop_age: contentVideoCurrent.crop_age,
      state: contentVideoCurrent.stateData.name_en,
      // position: location.state.position,
      // user_type: location.state.userType,
      // farmer_crops: JSON.stringify(location.state.farmerCrops),
      crop_segment: contentVideoCurrent.crop_segment,
      youtube_id: contentVideoCurrent.youtube_id,
      // user_source: location.state.userSource,
      page_name: window.location.pathname,
      skus: contentVideoCurrent.skus,
    });
  };

  const getContentVideoFromYoutubeURL = (videoUrl) => {
    let youtubeId = "";

    let contentVideo = null;

    if (videoUrl) {
      youtubeId = videoUrl.split("v=").pop();
    } else {
      return null;
    }
    return _.filter(contentVideos, (contentVideo) => {
      return contentVideo.youtube_id === youtubeId;
    })?.[0];
  };

  const getContentVideoFromYoutubeId = (youtubeId) => {
    let contentVideo = null;

    return _.filter(contentVideos, (contentVideo) => {
      return contentVideo.youtube_id === youtubeId;
    })?.[0];
  };

  const contentVideoRetriever = _.memoize(getContentVideoFromYoutubeURL);

  const handlePlaybackStart = (videoUrl, duration) => {
    if (videoUrl && videoUrl !== "" && contentVideos.length > 0) {
      // let contentVideo = location.state.contentVideo;
      let contentVideo = getContentVideo();
      let contentVideoFromId = contentVideoRetriever(videoUrl);

      setContentVideoCurrent(contentVideoFromId);
      if (contentVideoFromId) {
        VideosService.logVideoActivity(contentVideoFromId.youtube_id, "viewed")
          .then((responseLog) => {})
          .catch((error) => {
            console.log(error?.data);
          });
        firebase.analytics().logEvent("content_video_playback_started", {
          flow: "from-crop-page",
          crop_name: contentVideoFromId.cropData.name_en,
          author_name: contentVideoFromId.authorData.name_en,
          title: contentVideoFromId.title,
          weeks_after_sowing: contentVideoFromId.weeks_after_sowing,
          stage: contentVideoFromId.stageData.name_en,
          crop_age: contentVideoFromId.crop_age,
          state: contentVideoFromId.stateData.name_en,
          // position: location.state.position,
          // user_type: location.state.userType,
          // farmer_crops: JSON.stringify(location.state.farmerCrops),
          crop_segment: contentVideoFromId.crop_segment,
          youtube_id: contentVideoFromId.youtube_id,
          // user_source: location.state.userSource,
          total_duration: duration,
          skus: contentVideoFromId.skus,
        });
      } else {
        firebase.analytics().logEvent("content_video_playback_started", {
          mobile,
          flow: "shared-url",
          youtube_id: youtubeIdFromRoute,
          crop_name: cropNameFromRoute,
          duration: 60,
          total_duration: duration,
        });
      }
    }
  };
  const handlePlaybackEnd = (videoUrl, duration) => {
    if (videoUrl && contentVideos.length > 0) {
      //   let contentVideo = location.state.contentVideo;
      let contentVideo = getContentVideo();
      let contentVideoFromId = contentVideoRetriever(videoUrl);
      firebase.analytics().logEvent("content_video_playback_ended", {
        flow: "from-crop-page",
        crop_name: contentVideoFromId.cropData.name_en,
        author_name: contentVideoFromId.authorData.name_en,
        title: contentVideoFromId.title,
        weeks_after_sowing: contentVideoFromId.weeks_after_sowing,
        stage: contentVideoFromId.stageData.name_en,
        crop_age: contentVideoFromId.crop_age,
        state: contentVideoFromId.stateData.name_en,
        // position: location.state.position,
        // user_type: location.state.userType,
        // farmer_crops: JSON.stringify(location.state.farmerCrops),
        crop_segment: contentVideoFromId.crop_segment,
        youtube_id: contentVideoFromId.youtube_id,
        // user_source: location.state.userSource,
        total_duration: duration,
        skus: contentVideoFromId.skus,
      });
    } else {
      firebase.analytics().logEvent("content_video_playback_ended", {
        mobile,
        flow: "shared-url",
        youtube_id: youtubeIdFromRoute,
        crop_name: cropNameFromRoute,
        duration: 60,
        total_duration: duration,
      });
    }
  };

  const handlePlaybackProgress = (videoUrl, duration) => {
    if (videoUrl && contentVideos.length > 0) {
      // let contentVideo = location.state.contentVideo;
      let contentVideo = getContentVideo();
      let contentVideoFromId = contentVideoRetriever(videoUrl);

      firebase.analytics().logEvent("content_video_watched", {
        flow: "from-crop-page",
        crop_name: contentVideoFromId.cropData.name_en,
        author_name: contentVideoFromId.authorData.name_en,
        title: contentVideoFromId.title,
        weeks_after_sowing: contentVideoFromId.weeks_after_sowing,
        stage: contentVideoFromId.stageData.name_en,
        crop_age: contentVideoFromId.crop_age,
        state: contentVideoFromId.stateData.name_en,
        // position: location.state.position,
        // user_type: location.state.userType,
        // farmer_crops: JSON.stringify(location.state.farmerCrops),
        crop_segment: contentVideoFromId.crop_segment,
        youtube_id: contentVideoFromId.youtube_id,
        duration: 30,
        // user_source: location.state.userSource,
        total_duration: duration,
        skus: contentVideoFromId.skus,
      });
    } else {
      firebase.analytics().logEvent("content_video_watched", {
        mobile,
        flow: "shared-url",
        youtube_id: youtubeIdFromRoute,
        crop_name: cropNameFromRoute,
        duration: 60,
        total_duration: duration,
      });
    }
  };

  const handleClose = () => {
    if (window.history?.length > 1) {
      window.history?.back();
    }
  };

  const numberOfDefaultVisibleContentVideos = 10;

  const handleImageError = (e) => {
    e.target.onerror = null;
    // e.target.style.display = 'none'
    e.target.src = "/icons/dummy.jpeg";
  };

  const getVideosCount = (crop, userState, userType) => {
    let videosCount = 0;
    let recordingsCount = 0;

    if (crop) {
      videosCount = CropService.getVideosCount(crop, userState, userType);
      setVideosCount(videosCount);
    }
  };

  const getContentVideosCount = (crop, userState) => {
    let videosCount = 0;
    let recordingsCount = 0;

    if (crop) {
      videosCount = CropService.getContentVideosCount(crop, userState);
      setContentVideosCount(videosCount);
    }
  };

  const fetchMeetings = async () => {
    console.log(localStorage.getItem("languageCode"));
    if (
      localStorage.getItem("mobile") &&
      localStorage.getItem("languageCode")
    ) {
      setLoadingCropList(true);
      let { crops, authors, states, stages } = props.referenceData;

      let userStateFromLocal = localStorage.state;
      let userLangCodeFromLocal = localStorage.languageCode;

      let userSourceFromLocal = localStorage.userSource;
      let userSourceVar = "";
      if (!userSourceFromLocal || userSourceFromLocal === "") {
        userSourceVar = "WEB";
      } else {
        userSourceVar = userSourceFromLocal;
      }
      setUserSource(userSourceVar);
      let userStateName = userStateFromLocal;
      let userLanguageCodeVar = userLangCodeFromLocal;

      let userResponse = await UserService.getUser();
      let userFromResponse = userResponse.data;
      console.log({ userFromResponse });
      if (userFromResponse.name) {
        setName(userFromResponse.name);
      }

      if (userFromResponse.premium === false) {
        setFree(true);
        freeVar = true;
        userTypeVar = "free";
        setUserType(userTypeVar);
        localStorage.setItem("premium", userFromResponse.premium);
      } else {
        if (userFromResponse.migrated === true) {
          userTypeVar = "free_premium";
          setUserType(userTypeVar);
        } else if (userFromResponse.subscription_type === "free_premium") {
          userTypeVar = "free_premium";
          setUserType(userTypeVar);
        }
        if (
          userFromResponse.subscription_type &&
          userFromResponse.subscription_type === "freemium_1_month"
        ) {
          userTypeVar = "freemium_1_month";
          setUserType(userTypeVar);
        }
      }
      let mobileVar = "";
      if (userFromResponse.mobile) {
        setMobile(userFromResponse.mobile);
        mobileVar = userFromResponse.mobile;
        firebase.analytics().setUserId(userFromResponse.mobile);
        firebase.analytics().logEvent("crop_details_page_viewed", {
          state_name: userStateName,
          mobile: userFromResponse.mobile,
          user_type: userTypeVar,
          user_source: userSourceVar,
          // gold_version: version,
        });
      }
      if (
        !userStateFromLocal ||
        userStateFromLocal === "" ||
        !userLangCodeFromLocal ||
        userLangCodeFromLocal === ""
      ) {
        if (userFromResponse.state) {
          let userStateFromResponse =
            userFromResponse.state.name_en.toLowerCase();
          let stateFromResponse = userFromResponse.state;
          localStorage.setItem("state", userStateFromResponse);
          setUserState(stateFromResponse);
          userStateName = userStateFromResponse;
          if (userFromResponse.state.language) {
            let userLangCodeFromResponse = userFromResponse.state.language.code;
            localStorage.setItem("languageCode", userLangCodeFromResponse);
            userLanguageCodeVar = userStateFromResponse;
            setUserLanguageCode(userLangCodeFromResponse);
          } else {
            userLanguageCodeVar = "mr";
            setUserLanguageCode("mr");
          }
        } else {
          setUserState(StateService.getStateByName(states, "maharashtra"));
          userStateName = "maharashtra";
          userLanguageCodeVar = "mr";
          setUserLanguageCode("mr");
        }
      } else {
        setUserState(StateService.getStateByName(states, userStateFromLocal));
        setUserLanguageCode(userLangCodeFromLocal);
      }

      console.log({ userLanguageCode });
      console.log({ userLangCodeFromLocal });
      if (userFromResponse.crops && userFromResponse.crops.length > 0) {
        let userCrops = userFromResponse.crops;

        userCrops = userCrops.filter((userCrop) => {
          return CropService.getCropByName(crops, userCrop.name)
            ? CropService.getCropByName(crops, userCrop.name)
            : false;
        });

        userCrops = userCrops.map((userCrop) => {
          if (cropFromRoute.name_en === userCrop.name) {
            return {
              ...userCrop,
              ...CropService.getCropByName(crops, userCrop.name),
              current: true,
            };
          } else {
            return {
              ...userCrop,
              ...CropService.getCropByName(crops, userCrop.name),
              current: false,
            };
          }
        });

        userCrops = userCrops.filter((userCrop) => {
          let videosCount = 0;
          videosCount = CropService.getVideosCount(
            userCrop,
            userStateName,
            userTypeVar
          );

          if (userCrop.type === "gold_crop") {
            if (videosCount && videosCount > 0) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        });

        userCrops = userCrops.map((userCrop) => {
          let videosCount = 0;
          videosCount = CropService.getVideosCount(
            userCrop,
            userStateName,
            userTypeVar
          );
          if (videosCount && videosCount > 0) {
            return { ...userCrop, total_videos_count: videosCount };
          } else {
            return { ...userCrop };
          }
        });

        let currentUserCrop = userCrops.filter((userCrop) => {
          return userCrop.current === true;
        })?.[0];

        userCrops = userCrops.filter((userCrop) => {
          return userCrop.current === false;
        });

        setCropList(userCrops);
        setLoadingCropList(false);

        if (currentUserCrop) {
          if (currentUserCrop.sowing_date) {
            setSowingDate(currentUserCrop.sowing_date);
            let momentSowingDate = moment(currentUserCrop.sowing_date).format(
              "DD-MMM-YYYY"
            );
            let currentDate = moment();
            let currentDaysAfterSowing = currentDate.diff(
              momentSowingDate,
              "days"
            );
            let currentWeeksAfterSowing = Math.floor(
              currentDaysAfterSowing / 7
            );
            setCurrentDaysAfterSowing(currentDaysAfterSowing);
            setCurrentWeeksAfterSowing(currentWeeksAfterSowing);
          }
        }

        if (cropFromRoute && cropFromRoute.name_en) {
          let userStateFromLocal = localStorage.state;
          let userStateObject = StateService.getStateByName(
            states,
            userStateFromLocal
          );
          console.log({ userStateObject });
          if (userStateObject && userStateObject.code) {
            VideosService.getVideosForCropByState(
              cropFromRoute.name_en,
              userStateObject.code
            ).then((videosResponse) => {
              if (
                videosResponse &&
                videosResponse.data &&
                videosResponse.data.responseData &&
                videosResponse.data.responseData.length > 0
              ) {
                let videosData = videosResponse.data.responseData;
                videosData = videosData.map((contentVideo) => {
                  if (contentVideo && contentVideo.youTubeId) {
                    let youtube_id = contentVideo.youTubeId;
                    let youtube_thumbnail = `https://i.ytimg.com/vi/${youtube_id}/mqdefault.jpg`;
                    if (contentVideo.segment && contentVideo.author) {
                      let cropObj = CropService.getCropByName(
                        crops,
                        contentVideo.segment
                      );
                      let authorObj = AuthorService.getAuthorByName(
                        authors,
                        contentVideo.author
                      );
                      let stateObj = StateService.getStateByCode(
                        states,
                        contentVideo.stateCode
                      );
                      let stageName = "";
                      let stageIcon = "";
                      let stageObj = {};
                      if (contentVideo.stage) {
                        stageObj = StageService.getStageByName(
                          stages,
                          contentVideo.stage
                        );
                        if (
                          stageObj &&
                          !_.isEmpty(stageObj) &&
                          stageObj[`name_${userLanguageCodeVar}`]
                        ) {
                          stageName = stageObj[`name_${userLanguageCodeVar}`];
                          if (stageObj.image_avatar) {
                            stageIcon = stageObj.image_avatar;
                          }
                        }
                      }
                      if (
                        cropObj &&
                        cropObj[`name_${userLanguageCodeVar}`] &&
                        authorObj &&
                        authorObj[`name_${userLanguageCodeVar}`]
                      ) {
                        return {
                          ...contentVideo,
                          youtube_id,
                          youtube_url: `https://youtu.be/${youtube_id}`,
                          crop: contentVideo.segment,
                          crop_segment: contentVideo.segment,
                          shares_count: contentVideo.shares,
                          views_count: contentVideo.views,
                          state: contentVideo.stateData?.name_en,
                          cropData: cropObj,
                          cropName: cropObj[`name_${userLanguageCodeVar}`],
                          authorData: authorObj,
                          authorName: authorObj[`name_${userLanguageCodeVar}`],
                          authorImage: authorObj.image_avatar,
                          stageData: stageObj,
                          stageName: stageName,
                          stageIcon: stageIcon,
                          stateData: stateObj,
                          youtube_thumbnail: youtube_thumbnail,
                        };
                      }
                    }
                  }
                });

                videosData = videosData.filter((video) => {
                  return video && video.youtube_id;
                });
                console.log({ videosData });
                setContentVideos(videosData);

                if (youtubeIdFromRoute) {
                  let contentVideo = _.filter(videosData, (contentVideo) => {
                    return contentVideo.youtube_id === youtubeIdFromRoute;
                  })?.[0];
                  console.log({ contentVideo });
                  console.log({ contentVideos });
                  let currentVideoPosition = _.findIndex(
                    videosData,
                    (videoElement) => {
                      return (
                        videoElement.youtube_id === contentVideo.youtube_id
                      );
                    }
                  );
                  if (currentVideoPosition !== -1) {
                  }
                  setContentVideoCurrent(videosData[currentVideoPosition]);
                  console.log({ currentVideoPosition });
                }
              }
            });
          }
        }
      }
    } else {
    }
  };
  const saveUserAndRedirect = (
    isNew,
    mobile,
    userState,
    userSource,
    languageCode
  ) => {
    console.log({ languageCode });
    UserService.saveUser(
      "",
      mobile,
      userState.name_en.toLowerCase(),
      true,
      false,
      isNew,
      userSource,
      languageCode
    );

    UserService.saveUser(
      "",
      mobile,
      true,
      false,
      isNew,
      userSource,
      languageCode
    );
    fetchMeetings().then(() => {});
    firebase.analytics().logEvent("signup_success", {
      mobile: mobile,
      stateName: userState.name_en.toLowerCase(),
      source: userSource,
    });
    if (!userSource) {
      // history.push("/dashboard");
    } else {
      if (userSource === "APP" || userSource === "EMBED") {
        // history.replace(`/dashboard?source=${userSource}`);
      } else {
        // history.push(`/dashboard?source=${userSource}`);
      }
    }
  };
  useEffect(() => {
    if (
      props.referenceData &&
      !_.isEmpty(props.referenceData) &&
      props.loadingMasterData === "done"
    ) {
      let queryParamString = window.location.search;
      let parsedParams = queryStringParser.parse(queryParamString);
      // {mobile: "9960342202", source: "APPMH", utm_source: "as_app"}
      if (
        parsedParams.mobile &&
        parsedParams.source &&
        parsedParams.utm_source
      ) {
        let validMobileRegex = /^[0-9]*$/;
        let mobileFromParam = null;
        if (parsedParams.mobile && validMobileRegex.test(parsedParams.mobile)) {
          mobileFromParam = parsedParams.mobile;
        }
        let stateFromParam = null;
        if (
          parsedParams.source &&
          parsedParams.source.length === 5 &&
          parsedParams.source.includes("APP")
        ) {
          let stateCode = parsedParams.source.split("APP").pop();

          let state = StateService.getStateByCode(
            props.referenceData.states,
            stateCode
          );
          if (state) {
            stateFromParam = state;
          }
        }
        let trafficSource = "";
        if (parsedParams.utm_source) {
          trafficSource = parsedParams.utm_source;
        }
        let userSourceFromParam = "";
        if (trafficSource === "as_app") {
          userSourceFromParam = "APP";
        } else if (trafficSource === "as_embedded_app") {
          userSourceFromParam = "EMBED";
        } else if (trafficSource === "as_embedded_app_croppage") {
          userSourceFromParam = "EMBED_CROP";
        } else {
          userSourceFromParam = "WEB";
        }

        setUserSource(userSourceFromParam);
        console.log({
          mobileFromParam,
          stateFromParam,
          trafficSource,
          userSourceFromParam,
        });

        UserService.signup(
          "",
          mobileFromParam,
          stateFromParam,
          userSourceFromParam
        )
          .then(async (response) => {
            if (response && response.data) {
              if (response.data.result === "success") {
                saveUserAndRedirect(
                  response.data.isNew,
                  mobileFromParam,
                  stateFromParam,
                  userSourceFromParam,
                  response.data.state.language.code
                );
              } else {
                if (response.data.data) {
                  saveUserAndRedirect(
                    response.data.data.isNew,
                    mobileFromParam,
                    stateFromParam,
                    userSourceFromParam,
                    response.data.data.state.language.code
                  );
                } else {
                  let eventData = {
                    state_name: stateFromParam.name_en,
                    mobileFromParam,
                  };

                  if (response.data.message) {
                    eventData.reason = response.data.message;
                  }
                  firebase.analytics().logEvent("joingold_failed", eventData);
                }
              }
            }
          })
          .catch((error) => {
            firebase.analytics().logEvent("joingold_failed", {
              state_name: stateFromParam.name_en,
              source: "APP_BANNER",
              mobileFromParam,
              reason: "SOMETHING_WENT_WRONG",
            });
          });
      } else {
        let loggedInFlag = UserService.checkUserLogin();
        if (loggedInFlag === true) {
          fetchMeetings().then(() => {});
        }
      }
    }
  }, [props.referenceData, props.loadingMasterData]);

  return (
    <>
      <BlockUi
        tag="div"
        keepInView
        // message={`Loading...`}
        sx={{ minHeight: "90vh" }}
        blocking={!contentVideoCurrent}
      >
        {contentVideoCurrent && (
          <div className={classes.root}>
            <ErrorBoundary page={"content-video-page"} section={"iframe"}>
              {/*<Grid*/}
              {/*  className={classes.closeButtonContainer}*/}
              {/*  container*/}
              {/*  direction="row"*/}
              {/*  justifyContent="flex-end"*/}
              {/*  alignItems="center"*/}
              {/*>*/}
              {/*  <IconButton onClick={handleClose} edge={"start"} size="large">*/}
              {/*    <Close className={classes.ytPlayerCloseIcon} />*/}
              {/*  </IconButton>*/}
              {/*</Grid>*/}

              <div className={classes.playerWrapper}>
                <ReactVideoPlayer
                  light={true}
                  // top={"5%"}
                  height={"52%"}
                  autoplay={true}
                  handlePlaybackStart={handlePlaybackStart}
                  handlePlaybackEnd={handlePlaybackEnd}
                  handlePlaybackProgress={handlePlaybackProgress}
                  id={youtubeIdFromRoute}
                  src={`https://www.youtube.com/watch?v=${youtubeIdFromRoute}`}
                  languageCode={language}
                />
              </div>

              <Container className={classes.videoMetadataShared}>
                {contentVideoCurrent && (
                  <>
                    <Grid
                      className={classes.titleContainer}
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="flex-start"
                    >
                      <Grid item xs={12}>
                        <Typography className={classes.contentVideoTitle}>
                          {contentVideoCurrent.title}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid
                      className={classes.viewsContainer}
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                    >
                      <Grid item xs={12}>
                        {contentVideoCurrent.views_count &&
                        contentVideoCurrent.views_count > 24 ? (
                          <IconButton
                            aria-label="views"
                            edge={"start"}
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            className={classes.viewsIconContainer}
                            size="large"
                          >
                            <Visibility className={classes.viewsIcon} />
                            <Typography
                              variant={"caption"}
                              className={classes.viewsCount}
                            >
                              {contentVideoCurrent.views_count}
                            </Typography>
                          </IconButton>
                        ) : (
                          <IconButton
                            edge={"start"}
                            aria-label="new"
                            className={classes.newTagContainer}
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            size="large"
                          >
                            <Typography
                              variant={"caption"}
                              className={classes.newTag}
                            >
                              {
                                messages[`cropPage.contentVideo.newTag`][
                                  language
                                ]
                              }
                            </Typography>
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>

                    <Grid
                      className={classes.authorContainer}
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                    >
                      <Grid item xs={2}>
                        <Avatar
                          aria-label="author"
                          src={`${
                            config.gcpBucketBase
                          }content${encodeURIComponent(
                            contentVideoCurrent.authorImage
                          )}?alt=media`}
                          className={classes.avatar}
                        >
                          {contentVideoCurrent.authorName && (
                            <>{contentVideoCurrent.authorName.charAt(0)}</>
                          )}
                        </Avatar>
                      </Grid>
                      <Grid item xs={10}>
                        <Typography className={classes.authorName}>
                          {messages["dashboard.live.byAuthor"][language]}
                          {contentVideoCurrent.authorName}
                        </Typography>
                      </Grid>
                    </Grid>
                  </>
                )}
              </Container>
              {contentVideoCurrent && (
                <Grid
                  className={classes.skusContainer}
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                >
                  <Grid item xs={9}>
                    {contentVideoCurrent?.skus &&
                      contentVideoCurrent.skus !== "" && (
                        <>
                          <Typography className={classes.skusTitle}>
                            {
                              messages[
                                `cropPage.contentVideo.productsInTheVideo`
                              ][language]
                            }
                          </Typography>
                          <Grid
                            className={classes.skusContainer}
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="flex-start"
                            spacing={1}
                          >
                            {contentVideoCurrent.skus.slice(0, 3).map((sku) => {
                              return (
                                <Grid item>
                                  <Card
                                    className={classes.skuCard}
                                    onClick={() => {
                                      firebase
                                        .analytics()
                                        .logEvent("app_pdp_opened", {
                                          flow: "from-crop-page",
                                          crop_name:
                                            contentVideoCurrent.cropData
                                              .name_en,
                                          author_name:
                                            contentVideoCurrent.authorData
                                              .name_en,
                                          title: contentVideoCurrent.title,
                                          weeks_after_sowing:
                                            contentVideoCurrent.weeks_after_sowing,
                                          stage:
                                            contentVideoCurrent.stageData
                                              .name_en,
                                          crop_age:
                                            contentVideoCurrent.crop_age,
                                          state:
                                            contentVideoCurrent.stateData
                                              .name_en,
                                          position: location.state.position,
                                          user_type: location.state.userType,
                                          farmer_crops: JSON.stringify(
                                            location.state.farmerCrops
                                          ),
                                          crop_segment:
                                            contentVideoCurrent.crop_segment,
                                          youtube_id:
                                            contentVideoCurrent.youtube_id,
                                          user_source:
                                            location.state.userSource,
                                          skus: contentVideoCurrent.skus,
                                        });
                                      window.location.replace(
                                        `https://agrostar.in/product/gold/${sku}?language=${language}`
                                      );
                                    }}
                                  >
                                    <CardMedia
                                      component={`img`}
                                      className={classes.skuImage}
                                      image={`https://static.agrostar.in/static/${sku}_1.jpg`}
                                      onError={handleImageError}
                                      height={45}
                                    />
                                    <Button
                                      variant={"contained"}
                                      color={"secondary"}
                                      size={"small"}
                                      className={classes.skuClickHere}
                                      onClick={() => {
                                        console.log("clicked");
                                      }}
                                    >
                                      {
                                        messages[
                                          `cropPage.contentVideo.clickHereSKU`
                                        ][language]
                                      }
                                    </Button>
                                  </Card>
                                </Grid>
                              );
                            })}
                          </Grid>
                        </>
                      )}
                  </Grid>
                  <Grid item xs={3}>
                    {localStorage.getItem("mobile") !== "undefined" && (
                      <>
                        <Grid
                          container
                          spacing={0}
                          direction="column"
                          className={classes.socialActionContainer}
                          justifyContent="flex-end"
                          alignItems="flex-end"
                        >
                          <Grid item>
                            <WhatsappShareButton
                              url={`https://agrostar.onelink.me/9ngX/gold${
                                location?.state?.userState?.code
                                  ? location?.state?.userState?.code?.toLowerCase()
                                  : `mh`
                              }`}
                              title={`${getShareText()}`}
                              onClick={share}
                              className={classes.shareIconContainer}
                            >
                              <img
                                className={classes.shareIcon}
                                src={"../../../icons/whatsApp-circle.svg"}
                                alt="whatsapp-share"
                              />
                            </WhatsappShareButton>
                          </Grid>
                          <Grid item className={classes.sharesCountContainer}>
                            <Typography
                              variant={"caption"}
                              className={classes.sharesCount}
                            >
                              {contentVideoCurrent.shares_count}
                            </Typography>
                          </Grid>
                          <Grid item>
                            {contentVideoCurrent.likedByMe ? (
                              <IconButton
                                edge={"end"}
                                aria-label="unlike"
                                onClick={unlikeAVideo}
                                className={classes.likeButton}
                                size="large"
                              >
                                <img
                                  src={"../../../icons/liked-circle.svg"}
                                  className={classes.unlikeIcon}
                                />{" "}
                              </IconButton>
                            ) : (
                              <IconButton
                                edge={"end"}
                                aria-label="like"
                                onClick={likeAVideo}
                                className={classes.likeButton}
                                size="large"
                              >
                                <img
                                  src={"../../../icons/like-circle.svg"}
                                  className={classes.likeIcon}
                                />{" "}
                              </IconButton>
                            )}
                          </Grid>
                          <Grid item className={classes.likesCountContainer}>
                            <Typography
                              variant={"caption"}
                              className={classes.likesCount}
                            >
                              {contentVideoCurrent.likes || ``}
                            </Typography>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              )}
            </ErrorBoundary>
          </div>
        )}
      </BlockUi>
    </>
  );
}

export default ContentVideoDialog;
